import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getDspAccount, loginDsp, loginOtp } from '../../api/axios/crux/login'
import { LOGIN_STATUS } from './loginConstants'
import { kakaoLogin } from './kakaoAccount'

export const dspLogin = createAsyncThunk(
  'login/dspLogin',
  async (noArgs, { rejectWithValue }) => {
    try {
      await loginDsp()
      const { data: dspAccount } = await getDspAccount()
      return {
        dspAccount,
      }
    } catch (error) {
      return rejectWithValue(LOGIN_STATUS.FAIL)
    }
  }
)

export const otpLogin = createAsyncThunk('login/otpLogin', async () => {
  try {
    const { otp, accountId, adAccountId } = JSON.parse(
      sessionStorage.getItem('otp')
    )
    const { data } = await loginOtp({
      otp,
      accountId,
      adAccountId,
    })
    return data
  } catch (error) {
    sessionStorage.removeItem('otp')
    kakaoLogin()
  }
})

const loginSlice = createSlice({
  name: 'login',
  initialState: {
    loginStatus: LOGIN_STATUS.IDLE,
    kakaoEmail: '',
    current: undefined,
    admin: undefined,
  },

  extraReducers: builder => {
    builder.addCase(dspLogin.pending, state => {
      state.loginStatus = LOGIN_STATUS.IDLE
    })

    builder.addCase(dspLogin.fulfilled, (state, { payload }) => {
      if (payload.dspAccount) {
        state.current = payload.dspAccount
        state.kakaoEmail = payload.dspAccount.kakaoEmail
      }
      state.loginStatus = LOGIN_STATUS.SUCCESS
    })

    builder.addCase(dspLogin.rejected, (state, { payload }) => {
      state.loginStatus = payload
    })

    builder.addCase(otpLogin.pending, state => {
      state.loginStatus = LOGIN_STATUS.IDLE
    })

    builder.addCase(otpLogin.fulfilled, (state, { payload }) => {
      state.admin = payload
      state.loginStatus = LOGIN_STATUS.SUCCESS
    })

    builder.addCase(otpLogin.rejected, state => {
      state.loginStatus = LOGIN_STATUS.UNAUTHORIZED
    })
  },
})

const { reducer } = loginSlice
export default reducer
